import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './DashboardHome.css';
// Données fictives pour la démonstration
const demoData = {
  totalOrders: 156,
  totalRevenue: 8750.50,
  topRestaurants: [
    { id: 1, name: "Le Gourmet", orders: 42, revenue: 2450.75 },
    { id: 2, name: "Pizza Express", orders: 38, revenue: 1840.20 },
    { id: 3, name: "Sushi Master", orders: 31, revenue: 1680.90 },
  ],
  recentOrders: [
    { id: "#ORD5623", customer: "Jean Dupont", restaurant: "Le Gourmet", items: 3, total: 47.80, status: "Livré", date: "14/04/2025 14:32" },
    { id: "#ORD5622", customer: "Marie Leroy", restaurant: "Sushi Master", items: 2, total: 33.50, status: "En cours", date: "14/04/2025 13:15" },
    { id: "#ORD5621", customer: "Thomas Martin", restaurant: "Pizza Express", items: 4, total: 52.20, status: "Préparation", date: "14/04/2025 12:48" },
    { id: "#ORD5620", customer: "Lucie Bernard", restaurant: "Le Gourmet", items: 1, total: 18.90, status: "Livré", date: "14/04/2025 11:30" },
  ]
};

const DashboardHome = () => {
  const [dashboardData] = useState(demoData);
  const navigate = useNavigate();
  // Simuler un chargement de données depuis une API
  useEffect(() => {
    if (localStorage.getItem('adminLoggedIn') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);
    // Dans un cas réel, vous feriez un appel API ici
    // fetch('/api/admin/dashboard-stats')
    //   .then(response => response.json())
    //   .then(data => setDashboardData(data));
 

  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="dashboard-content">
        <AdminHeader title="Tableau de Bord" />
        
        <div className="dashboard-stats-container">
          <div className="stats-cards">
            <div className="stat-card">
              <div className="stat-icon orders-icon"></div>
              <div className="stat-details">
                <h3>Commandes Totales</h3>
                <p className="stat-value">{dashboardData.totalOrders}</p>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon revenue-icon"></div>
              <div className="stat-details">
                <h3>Chiffre d'Affaires</h3>
                <p className="stat-value">{dashboardData.totalRevenue.toFixed(2)}€</p>
              </div>
            </div>
          </div>
          
          <div className="dashboard-sections">
            <div className="dashboard-section">
              <h2>Restaurants Populaires</h2>
              <table className="dashboard-table">
                <thead>
                  <tr>
                    <th>Restaurant</th>
                    <th>Commandes</th>
                    <th>Chiffre d'Affaires</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboardData.topRestaurants.map(restaurant => (
                    <tr key={restaurant.id}>
                      <td>{restaurant.name}</td>
                      <td>{restaurant.orders}</td>
                      <td>{restaurant.revenue.toFixed(2)}€</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="section-footer">
                <Link to="/admin/restaurants">Voir tous les restaurants →</Link>
              </div>
            </div>
            
            <div className="dashboard-section">
              <h2>Commandes Récentes</h2>
              <table className="dashboard-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Client</th>
                    <th>Restaurant</th>
                    <th>Total</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboardData.recentOrders.map(order => (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>{order.customer}</td>
                      <td>{order.restaurant}</td>
                      <td>{order.total.toFixed(2)}€</td>
                      <td><span className={`status-badge status-${order.status.toLowerCase().replace(' ', '-')}`}>{order.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="section-footer">
                <Link to="/admin/orders">Gérer les commandes →</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;